<template>
  <div class="maintenance-records" :style="containerStyle">
    <div class="chart-title">工单记录</div>
    <div class="work-order-header">
      <div class="header-item">生成时间</div>
      <div class="header-item">记录类型</div>
      <div class="header-item">紧急程度</div>
      <div class="header-item">处理状态</div>
    </div>
    <div class="work-order-table">
      <div
        class="work-order-row"
        v-for="(record, index) in records"
        :key="index"
        @click="showWorkOrderDetail(record)"
        style="cursor: pointer"
      >
        <div class="work-order-cell">{{ record.createTime }}</div>
        <div class="work-order-cell">{{ record.orderType }}</div>
        <div class="work-order-cell">
          {{ record.urgency }}
        </div>
        <div class="work-order-cell">{{ record.status }}</div>
      </div>
    </div>

    <!-- 工单详情弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>工单详情</h3>
          <span class="close-btn" @click="closeModal">&times;</span>
        </div>
        <div class="modal-body">
          <div class="detail-grid">
            <div class="detail-item">
              <label>ID：</label>
              <span>{{ selectedRecord.id || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>小区地址：</label>
              <span>{{ selectedRecord.communityAddress || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>紧急程度：</label>
              <span>{{ selectedRecord.urgency || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>工单类型：</label>
              <span>{{ selectedRecord.orderType || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>上报员工：</label>
              <span>{{ selectedRecord.reportEmployee || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>负责员工：</label>
              <span>{{ selectedRecord.responsibleEmployee || "-" }}</span>
            </div>

            <div class="detail-item">
              <label>生成时间：</label>
              <span>{{ selectedRecord.createTime || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>完成时间：</label>
              <span>{{ selectedRecord.completeTime || "-" }}</span>
            </div>
            <div class="detail-item full-width">
              <label>状态：</label>
              <span>{{ selectedRecord.status || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>工单事件：</label>
              <span>{{ selectedRecord.orderEvent || "-" }}</span>
            </div>
            <div class="detail-item">
              <label>维修描述：</label>
              <span>{{ selectedRecord.repairContent || "-" }}</span>
            </div>

            <div class="detail-item">
              <label>工单图片：</label>
              <div class="image-container">
                <template v-if="getImagesArray(selectedRecord.orderImage).length">
                  <img
                    v-for="(img, idx) in getImagesArray(selectedRecord.orderImage)"
                    :key="idx"
                    :src="img"
                    alt="工单图片"
                    class="detail-image"
                    @click="openImagePreview(img)"
                  />
                </template>
                <span v-else>暂无图片</span>
              </div>
            </div>

            <div class="detail-item">
              <label>维修图片：</label>
              <div class="image-container">
                <template v-if="getImagesArray(selectedRecord.repairImage).length">
                  <img
                    v-for="(img, idx) in getImagesArray(selectedRecord.repairImage)"
                    :key="idx"
                    :src="img"
                    alt="维修图片"
                    class="detail-image"
                    @click="openImagePreview(img)"
                  />
                </template>
                <span v-else>暂无图片</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片放大预览层 -->
    <div v-if="showImagePreview" class="image-preview-overlay" @click="closeImagePreview">
      <div class="image-preview-content" @click.stop>
        <img :src="previewImageUrl" class="preview-image" />
        <span class="close-preview-btn" @click="closeImagePreview">&times;</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkOrderRecords",
  props: {
    records: {
      type: Array,
      required: true,
      default: () => [],
    },
    containerStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showModal: false,
      selectedRecord: {},
      showImagePreview: false,
      previewImageUrl: "",
    };
  },
  methods: {
    showWorkOrderDetail(record) {
      this.selectedRecord = record;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.selectedRecord = {};
    },
    getImagesArray(imageStr) {
      if (!imageStr) return [];
      return imageStr.split(',').map(url => url.trim()).filter(url => url);
    },
    openImagePreview(url) {
      this.previewImageUrl = url;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = "";
    },
  },
};
</script>

<style scoped lang="less">
// 维保作业样式
.maintenance-records {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

// 图表标题样式 - 与页面保持一致
.chart-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

// 弹窗样式
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: linear-gradient(135deg, #0a1929 0%, #1a2332 50%, #0e2a42 100%);
  border: 1px solid rgba(0, 212, 255, 0.5);
  border-radius: 10px;
  width: 90%;
  max-width: 800px;
  max-height: 90%;
  overflow-y: auto;
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(0, 212, 255, 0.3);
}

.modal-header h3 {
  color: #00d4ff;
  margin: 0;
  font-size: 18px;
}

.close-btn {
  color: #00d4ff;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ff3366;
}

.modal-body {
  padding: 20px;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.detail-item {
  display: flex;
  gap: 8px;
}

.detail-item.full-width {
  grid-column: 1 / -1;
  display: flex;
  align-items: flex-start;
  gap: 5px;
}

.detail-item.full-width label {
  margin-bottom: 5px;
}

.detail-item label {
  color: #88c4ff;
  font-size: 12px;
  margin-bottom: 0;
  font-weight: bold;
  flex-shrink: 0;
}

.detail-item span {
  color: #ffffff;
  font-size: 14px;
  text-align: left;
}

.description-box {
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 5px;
  padding: 10px;
  color: #ffffff;
  font-size: 14px;
  min-height: 60px;
  line-height: 1.4;
}

.image-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.detail-image {
  max-width: 200px;
  max-height: 150px;
  border-radius: 5px;
  border: 1px solid rgba(0, 212, 255, 0.3);
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s;
}

.btn-primary {
  background: rgba(0, 212, 255, 0.2);
  color: #00d4ff;
  border: 1px solid rgba(0, 212, 255, 0.5);
}

.btn-primary:hover {
  background: rgba(0, 212, 255, 0.3);
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.3);
}

.btn-secondary {
  background: rgba(255, 51, 102, 0.2);
  color: #ff3366;
  border: 1px solid rgba(255, 51, 102, 0.5);
}

.btn-secondary:hover {
  background: rgba(255, 51, 102, 0.3);
  box-shadow: 0 0 8px rgba(255, 51, 102, 0.3);
}

.work-order-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 10px;
}

.work-order-header .header-item {
  font-weight: bold;
  color: #00d4ff;
  flex: 1;
  text-align: center;
  font-size: 13px;
}

.work-order-table {
  flex: 1;
  overflow-y: auto;
}

.work-order-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
}

.work-order-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.work-order-cell {
  color: #ffffff;
  font-size: 12px;
  flex: 1;
  text-align: center;
}

.work-order-cell:first-child {
  color: #00d4ff;
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}

// 缩略图样式
.detail-image {
  max-width: 80px;
  max-height: 60px;
  border-radius: 5px;
  border: 1px solid rgba(0, 212, 255, 0.3);
  cursor: zoom-in;
  object-fit: cover;
}

// 图片预览层
.image-preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.image-preview-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.preview-image {
  max-width: 80vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.5);
}

.close-preview-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ff3366;
  color: #fff;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }


</style>
